var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8771 5.59157C22.9253 5.72709 22.9353 5.87891 22.8933 6.03327L18.4341 22.3947C18.2534 23.0578 17.2699 23.1325 17.0214 22.4025L15.5944 18.2117C15.4984 17.9296 15.1918 17.7788 14.9097 17.8748C14.6277 17.9709 14.4769 18.2774 14.5729 18.5595L15.9999 22.7503C16.568 24.4189 18.9957 24.438 19.4752 22.6784L23.9344 6.31701C24.0867 5.75821 23.9637 5.21615 23.6716 4.797L23.6924 4.7762L22.9853 4.06909L22.8982 4.15617C22.5357 3.99454 22.1143 3.94809 21.683 4.06565L5.32158 8.52476C3.562 9.00431 3.58111 11.432 5.2497 12.0001L9.44053 13.4271C9.72261 13.5231 10.0291 13.3723 10.1252 13.0903C10.2212 12.8082 10.0704 12.5017 9.78834 12.4056L5.59751 10.9787C4.86751 10.7301 4.94224 9.74658 5.60532 9.56586L21.9405 5.1139L12.794 14.2604L13.5011 14.9675L22.8771 5.59157Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.27c543d97bc257860ae6c3e3600d2d44.svg";
export { ForwardRef as ReactComponent };